import {
  Box,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  Grid,
  // Button,
  SvgIcon,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { Search as SearchIcon } from 'react-feather';

const EventListToolbar = ({ style, onSearch = () => {} }) => (
  <Card {...style}>
    <Grid container>
      <Grid item xs={10}>
        <CardContent>
          <Box sx={{ maxWidth: 500 }}>
            <TextField
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SvgIcon
                      fontSize="small"
                      color="action"
                    >
                      <SearchIcon />
                    </SvgIcon>
                  </InputAdornment>
                )
              }}
              onChange={(e) => onSearch(e.target.value)}
              placeholder="Search Event"
              variant="outlined"
            />
          </Box>
        </CardContent>
      </Grid>
    </Grid>
  </Card>
);

EventListToolbar.propTypes = {
  style: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]),
  onSearch: PropTypes.func
};

EventListToolbar.defaultProps = {
  style: [],
};
export default EventListToolbar;
